/**
 * @file   src\pages\WantadDetails.js
 * @brief  This file is responsible for showing want ad details page
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect, useLayoutEffect } from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
// import CommonHeader from "../../components/Onboarding/v2/CommonHeader";
import CommonHeader from "../../components/Onboarding/CommonHeader";
import StrengthenIcon from "../../images/ad-strengthen-icon.svg";
import AdIntroIcon from "../../images/ad-intro-icon.svg";
import LakeViewIcon from "../../images/lake-view-icon.svg";
import ConsumerIcon from "../../images/consumer-icon.svg";
import FinancingIcon from "../../images/financing-icon.svg";
import DisplacedFired from "../../images/v2/displaced-fire.svg";
import PrResIcon from "../../images/primary-residence-icon.svg";
import ShareIcon from "../../images/share-icon.svg";
import MoreIcon from "../../images/more-icon.svg";
import ReportWantAdModal from "../../components/MemberWantAd/ReportWantAdModal";
import ViewWantAdIntroductions from "../../components/Introduction/ViewWantAdIntroductions";
import ViewIntroductionModal from "../../components/Introduction/v2/ViewIntroductionModal";
import { usePrevious } from "../../hooks/usePrevious";
import ArchiveModal from "../../components/MyWantAd/ArchiveModal";
import PremiumPlanModal from "../../components/PlanUpgrade/PremiumPlanModal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {
  getPropertyIcon,
  getTooltipText,
  getCombinedText,
} from "../../helpers/getPropertyIcons";
import DefaultProfile from "../../images/v2/Profiles.svg";
import {
  BUY,
  LONG_RENT,
  SHORT_RENT,
  LOT_LAND,
  WANT_AD_KEY,
  USER_INFO_KEY,
  INVENTORY_KEY,
  STRENGTHEN_WANT_AD_KEY,
  IS_MULTI_FAMILY,
  IS_LAND,
  PRO_MEMBER_PLAN,
  INVESTOR_MEMBER_PLAN,
  USER_TYPE_AGENT,
} from "../../constants/common";
import ShareYourAdModal from "../../components/MemberWantAd/v2/ShareYourAdModal";
import ShareMyWantAdSmallModal from "../../components/MemberWantAd/ShareMyWantAdSmallModal";
import {
  loadTimeLineHtml,
  getLocalStorage,
  setLocalStorage,
  getUserId,
  loggedInUser,
  getUserType,
  loadPreferredLocationHtml,
  loadCompensationText,
  locationDisplay,
  loadBuyerAgreementHtml,
  saveTutorialStatusToLocal,
  checkTutorialDisplayStatus,
} from "../../helpers/v2/common";
import { pageURLs } from "../../constants/pageURLs";
import {
  useNavigate,
  useSearchParams,
  NavLink,
  useParams,
} from "react-router-dom";
import {
  favouriteWantAd,
  getAgentsList,
  getWantAdById,
  unFavouriteWantAd,
  archiveWantAd,
  unArchiveWantAd,
  deleteWantAd,
  getWantAdByIdPublic,
  getBoundaryCoordinates,
} from "../../services/v2/wantAdService";
import { convertToNumber } from "../../helpers/validations";
import SendIntroduction from "../../components/Introduction/SendIntroduction";
import HearttIcon from "../../images/heart-icon.svg";
import HearttIconFilled from "../../images/heart-icon-filled.svg";
import { getIntroductions } from "../../services/introductionService";
import { getIntroductionDetaisById } from "../../services/introductionService";
import AddToClientWantAdModal from "../../components/MemberWantAd/AddToClientWantAdModal";
import { handleTextBoxChange } from "../../actions/common";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Common/DeleteModal";
import {
  buildWantAdMustHavesHTML,
  loadInvestmentCriteria,
} from "../../helpers/v2/createWantAd";
import WantadDetailsSkeleton from "../WantadDetailsSkeleton";
import base64 from "base-64";
import utf8 from "utf8";
import { useRef } from "react";
import { useSelector } from "react-redux";
import AgentProfileViewModal from "../../components/Introduction/AgentProfileViewModal";
import MinCapIcon from "../../images/minimum-icn.svg";
import userProfile from "../../appState/userProfile";
import { getUserPlanDetails } from "../../services/userprofileService";
import ShareCard from "../../components/MemberWantAd/v2/ShareCard";
import MapBoxComponent from "../../components/Common/MapboxComponent";
import { shareWantAdSocial } from "../../services/v2/wantAdService";
import PremiumFeatureStar from "../../images/v2/premium-features-stars.svg";
import AddPropertyIcon from "../../images/add-property-plus-icon.svg";
import NoWantAdFoundModal from "../../components/MemberWantAd/v2/NoWantAdFound";
import ToolTip from "../../components/Common/ToolTip";
import TextBox from "../../components/Common/TextBox";
import TextArea from "../../components/Common/TextArea";
import IntroTutorialModal from "../../components/Tutorial/IntroTutorialModal";
import JoyRide, { STATUS } from "react-joyride";
import IntroductionTutorialIconStep1 from "../../images/tut-property-icon.svg";
import IntroductionTutorialIconStep2 from "../../images/tut-askingprice-icon.svg";
import IntroductionTutorialIconStep3 from "../../images/tut-custommsg-icon.svg";
import IntroductionTutorialIconStep4 from "../../images/tut-send-icon.svg";
import DocumentationTutorial from "../../components/Tutorial/DocumentationTutorial";
// import Sidebar from "../../components/Onboarding/v2/Sidebar";

const WantadDetails = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  searchParams.get("wantAdId");
  const id = searchParams.get("wantAdId");
  let decodedId;
  let idFromURL;
  try {
    const bytes = base64.decode(id);
    decodedId = utf8.decode(bytes);
    if (decodedId) {
      let decodedData = decodedId.split("-");
      idFromURL = decodedData.length > 0 ? decodedData[1] : null;
    }
  } catch {}

  const [showShareModal, setShareModal] = useState(false);
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);

  const [showSuccessModal, setSuccessModal] = useState(false);
  const [showReportModal, setReportModal] = useState(false);
  const handleClose = () => setShareModal(false);
  const [showStrengthen, setShowStrengthen] = useState(false);
  const [adDetails, setAdDetails] = useState();
  const [currPage, setCurrPage] = useState(1);
  const [showViewIntroductionModal, setViewIntroductionModal] = useState(false);
  const adType = _.get(adDetails, "adType", "");
  const createdUserTypeId = _.get(adDetails, "userTypeId", "");
  const propertyType = convertToNumber(_.get(adDetails, "prprtyType", ""));
  const adTypeBasedOnProperty = propertyType === 6 ? LOT_LAND : adType;
  const isAdTypeIsLand = adTypeBasedOnProperty === LOT_LAND;
  const nice2Have = _.get(adDetails, "nice2Have", []);
  const [introductionList, setIntroductionList] = useState([]);
  const [introCount, setIntroCount] = useState(0);
  const [polygonCoordinates, setPolygonCoordinates] = useState([]);
  const wantAd = getLocalStorage(WANT_AD_KEY);
  const userType = getUserType();
  //This variable is used for hiding strengthen want ad section and change intro title and description, if this page reaches from home feed.
  const isFromHomeFeed = idFromURL
    ? true
    : _.get(wantAd, "isFromHomeFeed", false);
  //This variable is used for hiding strengthen want ad section and change intro title and description, if this page reaches from all introductions.
  const isFromAllIntroduction = _.get(wantAd, "isFromAllIntroduction", false);
  const wantAdId = idFromURL ? idFromURL : _.get(wantAd, "wantAdId", null);
  const introId = _.get(wantAd, "introId", null);
  const isEdit = _.get(wantAd, "isEdit", false);
  const WantCreatedUserId = _.get(adDetails, "userId", false);
  const loggedInUserId = getUserId();
  const [introDetails, setIntroDetails] = useState([]);
  const [deleteModalShow, setDeleteModalShow] = useState(false); //
  const WantCreatedUserName =
    _.get(adDetails, "userFirstName", "") +
    " " +
    _.get(adDetails, "userLastName", "");
  const userCompany = _.get(adDetails, "userCompany", "");
  const syndicationFeed = _.get(adDetails, "syndicationFeed") ?? "public";
  const wantAdClientId = _.get(adDetails, "clientId", "");
  const syndicationPrivacy = _.get(adDetails, "syndicationPrivacy") ?? "hide";
  const lat = _.get(adDetails, "lat");
  const lng = _.get(adDetails, "lng");
  const mapRadius = _.get(adDetails, "mapRadius", null);
  const userAvatar = _.get(adDetails, "userAvatar", "");
  const isFavourite = _.get(adDetails, "isFavourite", false);
  const propertySubTypes = _.get(adDetails, "prptySubTypes", []);
  const handleIntroDetailModal = (modalState) =>
    setViewIntroductionModal(modalState);
  const INTRO_LIST_PAGE_LIMIT = 3;
  const previousPage = usePrevious(currPage);
  const isLoadIntroductionList =
    (isFromHomeFeed &&
      WantCreatedUserId &&
      WantCreatedUserId === loggedInUserId) ||
    (introId ? true : false);
  const mapImage = _.get(adDetails, "mapImg", null);
  const [isFavouriteStatus, setIsFavourite] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [modalShow, setModalShow] = useState(false); //
  const [searchText, setSearchText] = useState(""); //
  const [results, setResults] = useState([]);
  const [reloadAgents, setReloadAgents] = useState(0);
  const user = loggedInUser();
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const consumerType = adType == BUY ? "Buyer" : "Renter";
  const [archiveModalShow, setArchiveModalShow] = useState(false); //
  const [archiveStatus, setArchiveStatus] = useState(false); //
  const [reload, setReload] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [isWantAdCreated, setWantAdCreated] = useState(false);

  const [skeltonLoad, setSkeltonLoad] = useState(true); //
  const [noWantAdFound, setNoWantAdFound] = useState(false);
  const pageTopRef = useRef(null);
  const Is_Agent_Created = _.get(adDetails, "isAgentCreated", "");
  const [isPremiumUser, setIsPremiumUser] = useState(null);
  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );

  const [showAgentProfileViewModal, setAgentProfileViewModal] = useState(false);
  const agentProfileViewModalClose = () => setAgentProfileViewModal(false);
  const purchaseType = convertToNumber(_.get(adDetails, "prchTypeId", ""));
  const agentSlug = _.get(adDetails, "userSlug", "");
  const agentId = _.get(adDetails, "userId", "");
  const agentName =
    _.get(adDetails, "userFirstName", "") +
    " " +
    _.get(adDetails, "userLastName", "");
  const formattedAgentName = agentName.replace(/\s+/g, "-");
  const fireDisplaced = _.get(adDetails, "fireDisplaced", "");
  const zipcodes = _.get(adDetails, "zipCode", []);
  const userDetails = userProfile();
  const [userPlan, setUserPlan] = useState("");
  const [wantAdCreatedUserPlan, setWantAdCreatedUserPlan] = useState("");

  const [shareUrl, setShareUrl] = useState("");
  const [fbUrl, setFbUrl] = useState("");

  const tutorialPage = 5; //Want add tutorial
  let intoLinkDisplayStatus = checkTutorialDisplayStatus(tutorialPage);
  const [showIntroLink, setIntroLink] = useState(intoLinkDisplayStatus);
  const [showIntroTutorialModal, setIntroTutorialModal] = useState(false);
  const IntroTutorialModalClose = () => setIntroTutorialModal(false);
  const IntroTutorialShow = () => setIntroTutorialModal(true);
  const [displayTutorial, setDisplayTutorial] = useState(false);
  //Tutorial documentation section
  //Defining tutorial steps
  const acceptTutorial = () => {
    setIntroTutorialModal(false);
    setDisplayTutorial(true);
  };
  const [tutorialSteps, setTutorialSteps] = useState([
    {
      target: "#propertySelection",
      disableBeacon: true,
      placement: "left",
      title: "Choose a property to share",
      icon: IntroductionTutorialIconStep1,
      content:
        "If you have multiple properties, you can swap out which one you want to introduce.",
      hideCloseButton: true,
      showProgress: true,
      showSkipButton: true,
    },
    {
      target: ".property-price",
      disableBeacon: true,
      placement: "bottom",
      title: "Adjust asking price",
      icon: IntroductionTutorialIconStep2,
      content:
        "This is just conversation starter. So try not to overthink it. You can always change it later.",
      hideCloseButton: true,
      showProgress: true,
      showSkipButton: true,
    },
    {
      target: ".property-message",
      disableBeacon: true,
      placement: "top",
      title: "Write a custom message",
      icon: IntroductionTutorialIconStep3,
      content:
        "This is your first chance to tell them why you think your property is a perfect match.",
      hideCloseButton: true,
      showProgress: true,
      showSkipButton: true,
    },
    {
      target: ".sendMessageBtn",
      disableBeacon: true,
      placement: "left",
      title: "Review and send",
      icon: IntroductionTutorialIconStep4,
      content:
        "You'll get another chance to review your introduction before you finalize and send.",
      hideCloseButton: true,
      showProgress: true,
    },
  ]);

  //Tutorial tooltip
  const TutorialToolTip = ({
    continuous,
    index,
    step,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
    size,
    isLastStep,
    skipProps,
  }) => (
    <>
      <div {...tooltipProps}>
        <DocumentationTutorial
          continuous={continuous}
          index={index}
          step={step}
          backProps={backProps}
          skipProps={skipProps}
          primaryProps={primaryProps}
          isLastStep={isLastStep}
          size={size}
          finalStepBtn={"Got It!"}
        />
      </div>
    </>
  );

  //Tutorial status call back
  const handleJoyrideCallback = async (data) => {
    const { action, index, status, type, lifecycle } = data;
    if (
      [STATUS.FINISHED, STATUS.SKIPPED].includes(status) &&
      lifecycle == "complete"
    ) {
      setDisplayTutorial(false);
      setIntroLink(false);
      saveTutorialStatusToLocal(tutorialPage); //Save status
    }
  };

  const generateShareLink = async () => {
    if (!wantAdId || !loggedInUserId) {
      setShareUrl("");
      setFbUrl("");
      setImageUrl("");
      setShareModal(false);
      return;
    }

    try {
      const fbPayload = {
        wantAdId: _.get(wantAd, "wantAdId", wantAdId),
        platform: "facebook",
      };
      const response = await shareWantAdSocial(fbPayload);
      setShareUrl(response?.result?.shareUrl || "");
      setFbUrl(response?.result?.facebookShareUrl || "");
      setImageUrl(response?.result?.imageUrl || "");
    } catch (err) {
      console.error("Error generating share links:", err);
      setShareUrl("");
      setFbUrl("");
      setImageUrl("");
      setShareModal(false);
    }
  };

  const [isVertical, setIsVertical] = useState(false);
  //check if video is vertical
  useLayoutEffect(() => {
    const videoElement = document.getElementById("videoPlayer");
    if (videoElement) {
      const { videoWidth, videoHeight } = videoElement;
      setIsVertical(videoHeight > videoWidth);
    }
  });

  useEffect(() => {
    generateShareLink();
  }, [wantAdId]);

  const PremiumPlanModalClose = () => setPremiumPlanModal(false);
  const PremiumPlanModalShow = () => setPremiumPlanModal(true);
  useEffect(() => {
    if (idFromURL) {
      setLocalStorage(WANT_AD_KEY, { wantAdId: idFromURL });
    }
  }, [idFromURL]);

  useEffect(() => {
    if (userDetails) {
      if (userDetails?.length === 1) {
        if (userDetails[0]?.PlanName) {
          setUserPlan(userDetails[0]?.PlanName);
        }
      } else {
        if (userDetails[0]?.PlanName === "Trial") {
          setUserPlan(userDetails[1]?.PlanName);
        } else {
          setUserPlan(userDetails[0]?.PlanName);
        }
      }
    }
  }, [userDetails]);

  // useEffect(() => {
  //   if (userPlan === PRO_MEMBER_PLAN) {
  //     setIsPremiumUser(true);
  //   } else {
  //     setIsPremiumUser(false);
  //   }
  // }, [userPlan]);
  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      if (userDetailsFromStore[0]?.period !== 1 && userType === 2) {
        setIsPremiumUser(true);
      } else {
        setIsPremiumUser(false);
      }
    }
  }, [userDetailsFromStore]);

  useEffect(() => {
    getWantAdDetails(wantAdId);
    getCreatedUserPlan(wantAdId);
  }, [reload]);

  useEffect(() => {
    window.scrollTo(0, pageTopRef.current.offsetTop); // focus to the top section
    const showSuccess = _.get(wantAd, "showSuccess", null);
    if (showSuccess && !isFromHomeFeed && !isFromAllIntroduction) {
      setSuccessModal(true);
    } else if (
      !isFromHomeFeed &&
      !isFromAllIntroduction &&
      !introId &&
      WantCreatedUserId === loggedInUserId
    ) {
      setShareModal(true);
      setWantAdCreated(true);
    }
    getWantAdDetails(wantAdId);
  }, [
    introId,
    wantAdId,
    isFromHomeFeed,
    isFromAllIntroduction,
    WantCreatedUserId,
    loggedInUserId,
  ]);

  useEffect(() => {
    if (_.get(adDetails, "isAgentCreated", "") != 1) {
      if (
        (adTypeBasedOnProperty === BUY ||
          adTypeBasedOnProperty === LONG_RENT) &&
        !_.get(adDetails, "isStrengthen", false) &&
        !isFromHomeFeed &&
        !isFromAllIntroduction &&
        !introId &&
        isEdit == false &&
        WantCreatedUserId == loggedInUserId
      ) {
        setShowStrengthen(true);
      } else {
        setShowStrengthen(false);
      }
    }

    setIsFavourite(isFavourite);
  }, [adDetails]);

  //Fetch wantad details
  const getWantAdDetails = async (wantAdId) => {
    if (wantAdId && loggedInUserId) {
      const wantAdIdFromURL = params.wantAdId;
      await getWantAdById(wantAdIdFromURL, loggedInUserId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setSkeltonLoad(false);
            setAdDetails(responseResult);
            setLocalStorage(WANT_AD_KEY, {
              ...getLocalStorage(WANT_AD_KEY),
              wantAdType: responseResult?.adType,
              wantAdId: responseResult?.wantAdId,
            });
          } else {
            setNoWantAdFound(true);
            setSkeltonLoad(false);
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    } else {
      const wantAdId = params.wantAdId;
      await getWantAdByIdPublic(wantAdId, loggedInUserId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setSkeltonLoad(false);
            setAdDetails(responseResult);
            setLocalStorage(WANT_AD_KEY, {
              ...getLocalStorage(WANT_AD_KEY),
              wantAdId: responseResult?.wantAdId,
              wantAdType: responseResult?.adType,
            });
          } else {
            setNoWantAdFound(true);
            setSkeltonLoad(false);
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
      // navigate(pageURLs.home);
    }
  };

  //To fetch current subscription plan of user who has created wantad
  const getCreatedUserPlan = async (wantAdId) => {
    if (wantAdId) {
      await getUserPlanDetails({ wantAdId: wantAdId })
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setWantAdCreatedUserPlan(responseResult[0]?.PlanName);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  const updateIntroPageOnScroll = () => {
    setCurrPage((prevState) => prevState + 1);
  };

  useEffect(() => {
    isLoadIntroductionList && getIntroductionList(currPage, wantAdId);
  }, [currPage, introId, isLoadIntroductionList]);

  //Get introductions received against the wantad
  const getIntroductionList = async (page, wantAdId) => {
    const userId = _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "");
    const reqPayload = {
      wantAdId: wantAdId,
      page: previousPage === currPage ? 1 : page,
      limit: INTRO_LIST_PAGE_LIMIT,
      isAccept: "1",
    };
    await getIntroductions(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        const count = _.get(response, "result.Count", "");
        if (response.errorCode === 0) {
          if (!previousPage || previousPage === currPage) {
            setIntroductionList(list); // Loading new introduction list when selecting each introduction. So not appending with the existing list.
          } else if (previousPage !== currPage) {
            setIntroductionList([...introductionList, ...list]);
          }
          setIntroCount(count);
        } else {
          console.log(`####error`);
        }
      }
    });
  };
  // To show the share wantad popup
  const handleOnShare = () => {
    setWantAdCreated(false);
    setShareModal(true);
  };

  const handleStrengthenDismiss = () => setShowStrengthen(false);

  const showShareModalPopup = () => {
    setShareModal(true);
    setSuccessModal(false);
    updateLocalStorage();
  };

  /**
   *  Get introduction details by passsing introduction id
   */
  const getIntroductionDetails = async (introId, IsAccept = 0) => {
    if (IsAccept == 1 || IsAccept == true) {
      setLocalStorage(INVENTORY_KEY, {
        introductionId: introId,
        adType: adType,
      });
      navigate(pageURLs.viewIntroducedInventory);
    } else {
      handleIntroDetailModal(true);
      if (introId) {
        await getIntroductionDetaisById(introId)
          .then((response) => {
            const responseResult = _.get(response, "result", null);
            if (response.errorCode === 0 && responseResult) {
              setIntroDetails(responseResult);
            } else {
              console.log("Something went wrong");
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      } else {
      }
    }
  };

  const handleSuccessModalClose = () => {
    setSuccessModal(false);
    updateLocalStorage();
  };

  const handleReportPopup = (isShow) => setReportModal(isShow);

  const updateLocalStorage = () => {
    const wantAd = getLocalStorage(WANT_AD_KEY);
    const wantAdId = _.get(wantAd, "wantAdId", null);
    setLocalStorage(WANT_AD_KEY, { wantAdId: wantAdId });
  };

  const loadEachNiceToHave = (section) => {
    const selectedItems =
      nice2Have && nice2Have.filter((item) => item.tab === section);
    return loadNiceToHaveList(selectedItems, section.charAt(0));
  };

  const finalNiceToHaveList = () => {
    const niceToHaveMasterArray = isAdTypeIsLand
      ? ["Views", "Characteristics"]
      : ["Property", "Layout", "Interior", "Exterior", "Other"];
    const finalList =
      niceToHaveMasterArray &&
      niceToHaveMasterArray.map((nh) => {
        return loadEachNiceToHave(nh);
      });
    return finalList;
  };
  /**
   * Navigate to edit wantad on selecting edit option from dropdown menu
   */
  const onEdit = () => {
    if (userType == 2) {
      navigate("/agent-create-want-ad", { state: { data: adDetails } });
    } else {
      navigate("/edit-want-ad", { state: { data: adDetails } });
    }
  };

  const onWantAdDelete = () => {
    setDeleteModalShow(true);
  };

  /**
   * To handle the want-ad delete
   */
  const handleDeleteWantAd = async () => {
    // setLoading(true)
    if (wantAdId) {
      await deleteWantAd(wantAdId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);

          if (response.errorCode === 0 && responseResult) {
            toast.success("Your want-ad has been deleted.");
            setDeleteModalShow(false);
            navigate("/my-want-ad");
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };
  /**
   * Show popup to handle pause want ad
   * @param {*} id
   */
  const onWantAdArchived = (id) => {
    setArchiveModalShow(true);
  };

  /**
   * To handle the want-ad  pause
   */
  const handleArchiveWantAd = async () => {
    if (wantAdId) {
      await archiveWantAd(wantAdId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            toast.dismiss();
            toast.success("Your want-ad has been paused.");
            setArchiveModalShow(false);
            setArchiveStatus(!archiveStatus);
            setReload(reload + 1);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  /**
   * To handle the want-ad un pause
   */
  const handleUnArchiveWantAd = async (wantAd) => {
    if (wantAd?.wantAdId) {
      if (
        (wantAd?.Buy_or_Rent == 2 && wantAd?.Move_in_TimeLine == 11) ||
        wantAd?.Buy_or_Rent == 3
      ) {
        if (userType == 2) {
          navigate("/agent-create-want-ad", {
            state: { data: adDetails, isFromUnPause: true },
          });
        } else {
          navigate("/edit-want-ad", {
            state: { data: adDetails, isFromUnPause: true },
          });
        }
      } else {
        await unArchiveWantAd(wantAd?.wantAdId)
          .then((response) => {
            if (response.errorCode == 0) {
              toast.dismiss();
              toast.success("Your paused want-ad has been made public again.");
              setArchiveStatus(!archiveStatus);
              setReload(reload + 1);
            } else {
              console.log("Something went wrong");
            }
          })
          .catch((err) => {
            console.log("Error", err);
          });
      }
    }
  };

  /**
   * To load nice to have list view
   * @param {*} list
   * @param {*} uniqueType
   * @returns
   */
  const loadNiceToHaveList = (list, uniqueType) => {
    return (
      list &&
      list.map((tl) => {
        const id = _.get(tl, "id");
        const itemText = _.get(tl, "text", "");
        const icon = _.get(tl, "icon", "");
        return (
          <div className="nicetohaves-tag" key={id + uniqueType}>
            <div className="nicetohaves-tag-icon">
              <img
                src={icon ? require("../../images/" + icon) : LakeViewIcon}
              />
            </div>
            <span className="wanted-details-itemtext">{itemText}</span>
          </div>
        );
      })
    );
  };

  /**
   * To handle display adTitle
   * @returns
   */
  const loadAdTitle = () => {
    let adTypeTile = "Buy";
    if (adType === LONG_RENT) {
      adTypeTile = "Rent";
    } else if (adType === SHORT_RENT) {
      adTypeTile = "Stay";
    }
    return (
      <>
        {" "}
        <span className="want-ad-tag align-middle green-tag-bg mb-0 f-size-10">
          {adTypeTile}
        </span>
      </>
    );
  };

  /**
   * To handle strengthen want ad details display
   * @returns
   */
  const loadStrengthenDetails = () => {
    if (_.get(adDetails, "isStrengthen", "")) {
      if (adType === BUY) {
        return (
          <>
            {" "}
            {_.get(adDetails, "prchTypeTxt", "") && (
              <li>
                <span className="list-icn-wrap">
                  <img src={PrResIcon} />
                </span>
                {_.get(adDetails, "prchTypeTxt", "")}
                {(_.get(adDetails, "is1031Exchange", "") == "Yes" ||
                  _.get(adDetails, "is1031Exchange", "") == 1) &&
                  " - 1031 exchange"}
              </li>
            )}
            {_.get(adDetails, "finTypeTxt", "") && (
              <li>
                <span className="list-icn-wrap">
                  <img src={FinancingIcon} />
                </span>
                Financing: {_.get(adDetails, "finTypeTxt", "")}
                {(_.get(adDetails, "isPreApprLoan", "") == "Yes" ||
                  _.get(adDetails, "isPreApprLoan", "") == 1) &&
                  "  - pre approved"}
              </li>
            )}
          </>
        );
      } else if (adType === LONG_RENT) {
        return (
          <>
            {" "}
            {_.get(adDetails, "creditScoreText", "") && (
              <li>
                <span className="list-icn-wrap">
                  <img src={FinancingIcon} />
                </span>
                Credit Score : {_.get(adDetails, "creditScoreText", "")}
              </li>
            )}
          </>
        );
      }
    }
  };
  /**
   * To display timeline in details
   * @returns
   */
  const loadTimeLine = () => {
    return loadTimeLineHtml(adType, adTypeBasedOnProperty, adDetails);
  };

  const loadBuyerAgreement = () => {
    return loadBuyerAgreementHtml(adDetails);
  };
  /**
   * To display preferred location
   * @returns
   */
  const loadPreferredLocation = () => {
    return loadPreferredLocationHtml(adDetails);
  };
  /**
   * To display musthaves section
   * @returns
   */
  const loadAdMustHaves = () => {
    return buildWantAdMustHavesHTML({
      adType: adType,
      adTypeBasedOnProperty: adTypeBasedOnProperty,
      formValues: adDetails,
    });
  };

  /**
   * To handle the want-ad favorite/unfavorite
   */
  const handleFavoriteOrUnfavoriteWantAd = async (
    IsFavourite,
    Want_ad_Id,
    clientId = [],
  ) => {
    if (Want_ad_Id) {
      let data = {
        clientId: IsFavourite == false ? clientId : null,
        wantAdId: Want_ad_Id,
      };
      await (
        IsFavourite == false ? favouriteWantAd(data) : unFavouriteWantAd(data)
      )
        .then((response) => {
          if (response.errorCode == 0) {
            let message = "";
            if (clientId.length > 0) {
              message =
                "Want-Ad has been favorited for " +
                clientId.length +
                (clientId.length > 1 ? " clients" : " client");
            } else {
              message =
                IsFavourite == true
                  ? "Want-Ad has been removed from your favorites"
                  : "Want-Ad has been added to your favorites";
            }

            toast.success(message);
            setModalShow(false);
            setIsFavourite(!IsFavourite);
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  /**
   *
   */
  useEffect(() => {
    getAgentsClientsList();
  }, [sessionData?.userInfo?.userId, searchText, reloadAgents]);

  /**
   * To handle textbox value change on agent client search
   * @param {any} event
   */
  const onChangeText = (event) => {
    let value = "";
    if (event) {
      value = handleTextBoxChange(event);
    }

    setSearchText(value);
  };

  /**
   * To get agents clients list
   * @param {*} query
   */
  const getAgentsClientsList = async (query) => {
    let a = {
      search: searchText,
      sortBy: "createdOn",
      sortDir: "desc",
    };
    await getAgentsList(a)
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (response.errorCode === 0 && responseResult) {
          setResults(responseResult);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  /**
   * to handle clients favorites action
   * @param {*} agentIds
   */
  const handleClientFavoriteWantAd = (agentIds) => {
    handleFavoriteOrUnfavoriteWantAd(isFavourite, wantAdId, agentIds);
  };

  /**
   * handle agents favorite action, to open client list popup
   */
  const handleAgentsFavoriteAction = () => {
    setModalShow(true);
  };

  const handleStrengthenClick = () => {
    const adDetails = getLocalStorage(WANT_AD_KEY);
    setLocalStorage(STRENGTHEN_WANT_AD_KEY, adDetails);
    navigate(pageURLs.wantAdStrengthen);
  };

  const isNiceToHaveExist = nice2Have.length > 0;
  const renderTooltip = (props) => (
    <Tooltip
      id="button-tooltip"
      placement="bottom-start"
      className="custom-tooltip"
      {...props}
    >
      {propertyType === IS_LAND || propertyType === IS_MULTI_FAMILY
        ? getTooltipText(propertyType)
        : propertySubTypes &&
          propertySubTypes.length > 0 &&
          getCombinedText(propertySubTypes)}
    </Tooltip>
  );

  //HANDLE ZIPCODE POLYGON
  const setBoundaryCoordinates = (zipCode) => {
    if (_.isEmpty(zipCode)) return;

    var payload = [];
    zipCode.map(function (item) {
      payload.push(item?.zipCode);
    });
    getBoundaryCoordinates({ zipCode: payload })
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        if (response.errorCode === 0 && responseResult) {
          let coordinates = [];
          let zipValues = [];
          responseResult.map((result) => {
            zipValues.push({ zipCode: result?.ZipCode, zipId: result?.ZipId });

            coordinates.push([result?.coordinates]);
          });
          setPolygonCoordinates(coordinates);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  useEffect(() => {
    setBoundaryCoordinates(zipcodes);
  }, [zipcodes]);

  return (
    <>
      <span ref={pageTopRef}></span>

      {displayTutorial ? (
        <JoyRide
          steps={tutorialSteps}
          tooltipComponent={TutorialToolTip}
          continuous
          callback={handleJoyrideCallback}
          disableScrolling={true}
        />
      ) : (
        ""
      )}

      {skeltonLoad ? (
        <WantadDetailsSkeleton />
      ) : (
        <>
          <div className="outer-wrap position-relative agent-no-login">
            <CommonHeader openSignIn="true" refresh={refresh} />
            <div className="m-0">
              <div className="left-sidebar p-0">{/* <Sidebar /> */}</div>
            </div>

            {!noWantAdFound && (
              <>
                {" "}
                <div className="main-content p-0 agent-no-login-content">
                  {(isFromHomeFeed || isFromAllIntroduction || introId) && (
                    <a
                      role="button"
                      className="bottom-back-btn mb-24 d-inline-block"
                      onClick={() => navigate(-1)}
                    >
                      <span className="left-arrow">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.73359 3.59957C6.92886 3.79483 6.92886 4.11142 6.73359 4.30668L3.54048 7.49979H13.6667C13.9429 7.49979 14.1667 7.72365 14.1667 7.99979C14.1667 8.27593 13.9429 8.49979 13.6667 8.49979H3.54048L6.73359 11.6929C6.92886 11.8882 6.92886 12.2048 6.73359 12.4C6.53833 12.5953 6.22175 12.5953 6.02649 12.4L1.97982 8.35335C1.88605 8.25958 1.83337 8.1324 1.83337 7.99979C1.83337 7.86718 1.88605 7.74001 1.97982 7.64624L6.02649 3.59957C6.22175 3.40431 6.53833 3.40431 6.73359 3.59957Z"
                            fill="#205ECA"
                          ></path>
                        </svg>
                      </span>
                      Back
                    </a>
                  )}
                </div>
                <div className="row">
                  <div className="col-12 col-md-7 ps-md-3 col-lg-8 ps-lg-3 col-xl-8 ps-xl-2">
                    <div className="wantad-confirmation-wrap mb-4">
                      <div className="confirmation-top-sec d-md-flex justify-content-between">
                        <div className="long-txt-fix">
                          {/* FIRE DISPLACED */}
                          {fireDisplaced ? (
                            <div className="dis-fires detail">
                              <img
                                src={DisplacedFired}
                                alt="displaced-fired"
                                className="displaced-fired"
                                width={"9px"}
                                height={"11px"}
                              />
                              DISPLACED BY FIRES
                            </div>
                          ) : null}
                          <div className="confirm-sub-title mb-1">
                            I'm looking to:
                            {loadAdTitle()}
                          </div>
                          <h2>
                            {_.get(
                              adDetails,
                              "adTitle",
                              "Cozy home for small family",
                            )}{" "}
                          </h2>
                          <span className="trailing-txt">
                            {locationDisplay(adDetails)}
                          </span>
                        </div>

                        {sessionData?.userInfo?.userId &&
                        WantCreatedUserId !== sessionData?.userInfo?.userId ? (
                          <div className="social-btns-wrap">
                            <Dropdown className="mr-12">
                              <Dropdown.Toggle variant="" id="dropdown-basic1">
                                <img src={MoreIcon} />
                              </Dropdown.Toggle>
                              <Dropdown.Menu align="end">
                                <Dropdown.Item onClick={() => handleOnShare()}>
                                  Share
                                </Dropdown.Item>
                                {WantCreatedUserId !==
                                  sessionData?.userInfo?.userId && (
                                  <Dropdown.Item
                                    onClick={() => handleReportPopup(true)}
                                  >
                                    Report
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                            <a
                              role="button"
                              href={void 0}
                              className="social-content-btn"
                            >
                              {isFavouriteStatus ? (
                                <img
                                  src={HearttIconFilled}
                                  onClick={() => {
                                    handleFavoriteOrUnfavoriteWantAd(
                                      true,
                                      wantAdId,
                                    );
                                  }}
                                />
                              ) : (
                                <img
                                  src={HearttIcon}
                                  onClick={() => {
                                    sessionData?.userInfo?.userType == 2 &&
                                    isPremiumUser
                                      ? handleAgentsFavoriteAction()
                                      : handleFavoriteOrUnfavoriteWantAd(
                                          false,
                                          wantAdId,
                                        );
                                  }}
                                />
                              )}
                            </a>
                          </div>
                        ) : (
                          <>
                            {sessionData?.userInfo?.userId ? (
                              <>
                                <div className="social-btns-wrap">
                                  <a
                                    role="button"
                                    className="social-content-btn mr-12"
                                    onClick={() => handleOnShare()}
                                  >
                                    <img src={ShareIcon} />
                                  </a>
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant=""
                                      id="dropdown-basic1"
                                    >
                                      <img src={MoreIcon} />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                      <Dropdown.Item onClick={() => onEdit()}>
                                        Edit
                                      </Dropdown.Item>
                                      {adDetails?.isArchived == 0 && (
                                        <Dropdown.Item
                                          onClick={() =>
                                            onWantAdArchived(wantAdId)
                                          }
                                        >
                                          Pause
                                        </Dropdown.Item>
                                      )}
                                      {adDetails?.isArchived == 1 && (
                                        <Dropdown.Item
                                          onClick={() =>
                                            handleUnArchiveWantAd(adDetails)
                                          }
                                        >
                                          Unpause
                                        </Dropdown.Item>
                                      )}
                                      <Dropdown.Item
                                        onClick={() => onWantAdDelete()}
                                      >
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </>
                            ) : null}
                          </>
                        )}
                      </div>

                      <div className="confirm-map-wrap">
                        {/* COMMENTED OVERLAY FOR NOW*/}
                        <OverlayTrigger
                          placement="bottom-start"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip}
                        >
                          <div
                            className={`property-tile w-auto ${fireDisplaced ? "firedisplaced" : ""}`}
                            style={{ zIndex: 99 }}
                          >
                            {propertyType === IS_LAND ||
                            propertyType === IS_MULTI_FAMILY ? (
                              <img
                                src={getPropertyIcon(propertyType)}
                                alt={getPropertyIcon(propertyType)}
                                className="property-icon-img"
                              />
                            ) : (
                              propertySubTypes &&
                              propertySubTypes.length > 0 &&
                              propertySubTypes.map((subtype) => {
                                return (
                                  <img
                                    src={getPropertyIcon(subtype)}
                                    alt={getPropertyIcon(subtype)}
                                    className="property-icon-img"
                                  />
                                );
                              })
                            )}
                          </div>
                        </OverlayTrigger>
                        <MapBoxComponent
                          center={[lng, lat]}
                          radiusMiles={mapRadius}
                          polygonCoordinates={polygonCoordinates}
                          showPolygon={zipcodes.length > 0}
                        />
                      </div>
                      {loadAdMustHaves()}

                      {isNiceToHaveExist ? (
                        <div className="nicetohaves-wrap">
                          <h2 className="wanted-details-head">Nice-to-haves</h2>
                          <div className="nicetohaves-inner-wrap">
                            {finalNiceToHaveList()}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {_.get(adDetails, "adDesc", "") ? (
                        <div className="nicetohaves-wrap">
                          <h2 className="wanted-details-head">Description</h2>
                          <p className="long-txt-fix timeline-value desc-block">
                            {_.get(adDetails, "adDesc", "")}
                          </p>
                        </div>
                      ) : (
                        ""
                      )}

                      {_.get(adDetails, "videoUrl", "") && (
                        <div className="video-wrap">
                          <video
                            id="videoPlayer"
                            controls
                            width={isVertical ? "300px" : "100%"} // Width 300px for vertical, auto for horizontal
                            height={isVertical ? "500px" : "auto"} // Auto height for vertical, 500px for horizontal
                            className="video-player"
                            preload="metadata"
                            poster={_.get(adDetails, "thumbnailImgUrl", "")}
                          >
                            <source
                              src={_.get(adDetails, "videoUrl", "")}
                              type="video/mp4"
                            />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      )}

                      <div
                        className={
                          (adType == BUY ||
                            _.get(adDetails, "prprtyType", "") == IS_LAND) &&
                          _.get(adDetails, "isAgentCreated", "") == 1 &&
                          _.get(adDetails, "compenationType", "") > 0
                            ? "buyer-info nicetohaves-wrap"
                            : "buyer-info"
                        }
                      >
                        <h2 className="wanted-details-head">
                          Additional details
                        </h2>
                        <ul>
                          <li>
                            {/* ------------------------- Commented on 02-03-2024 based on basecamp post Premium Agent to Premium Agent Visabile Profiles------------------- */}
                            {/* {
                          _.get(adDetails, "isPremiumAgent", "") == true && userType === USER_TYPE_AGENT && isPremiumUser && WantCreatedUserId !==
                          sessionData?.userInfo?.userId  ?

                            <div className="profile-pic-sec">
                              {_.get(adDetails, 'userImage', '') ?
                                <figure className="brdr-rs-200">
                                  <img className="brdr-rs-200" src={_.get(adDetails, 'userImage', '') ?? noImage} />
                                </figure>
                                :
                                <div className="profile-placeholder-wrap profile-bg-orange flex-shrink-0">
                                  {(_.get(adDetails, 'userFirstName', '') + " " + _.get(adDetails, 'userLastName', '')).replace(/-/g, "").match(/\b(\w)/g)}
                                </div>
                              }
                              <div className="profile-name">
                                <h6 className="d-flex mb-0">
                                  {_.get(adDetails, 'userFirstName', '') + " " + _.get(adDetails, 'userLastName', '')}
                                  <span className="pro-blue-badge">PRO</span>
                                </h6>
                                <p className="position mb-0">
                                  Agent @ {_.get(adDetails, "userCompany", "")}
                                </p>
                                <a role="button" onClick={agentProfileViewModalShow}>
                                  View bio
                                </a>
                              </div>
                            </div>

                            :
                            <> */}
                            {/* ------------------------- Commented on 02-03-2024 based on basecamp post Premium Agent to Premium Agent Visabile Profiles------------------- */}
                            {userType === USER_TYPE_AGENT ? (
                              <>
                                {/* this span tag code is for dp */}
                                <span className="list-icn-wrap">
                                  <img
                                    src={
                                      (isPremiumUser &&
                                        syndicationPrivacy === "show") ||
                                      (!isPremiumUser &&
                                        syndicationPrivacy === "show" &&
                                        syndicationFeed === "public")
                                        ? userAvatar || DefaultProfile
                                        : DefaultProfile
                                    }
                                    alt="avatar"
                                    className={`property-agent-profile${
                                      !isPremiumUser &&
                                      Is_Agent_Created &&
                                      syndicationFeed === "agents" &&
                                      !syndicationPrivacy === "show"
                                        ? "-blurred"
                                        : ""
                                    }`}
                                    width={"40px"}
                                    height={"40px"}
                                    style={{
                                      cursor:
                                        (isPremiumUser &&
                                          syndicationPrivacy === "show") ||
                                        (!isPremiumUser &&
                                          syndicationPrivacy === "show" &&
                                          syndicationFeed === "public")
                                          ? "pointer"
                                          : "default",
                                    }}
                                    onClick={() => {
                                      if (
                                        (isPremiumUser &&
                                          syndicationPrivacy === "show") ||
                                        (!isPremiumUser &&
                                          syndicationPrivacy === "show" &&
                                          syndicationFeed === "public")
                                      ) {
                                        navigate(`/agent-info/${agentSlug}`);
                                      }
                                    }}
                                  />
                                </span>
                                {_.get(adDetails, "isAgentCreated", "") == 1 &&
                                createdUserTypeId !== 1 ? (
                                  <div className="property-agent-details">
                                    <div className="property-agent-name">
                                      {(isPremiumUser &&
                                        syndicationPrivacy === "show") ||
                                      (!isPremiumUser &&
                                        syndicationPrivacy === "show" &&
                                        syndicationFeed === "public") ? (
                                        <>
                                          {WantCreatedUserName}
                                          <span className="pro-tag">PRO</span>
                                        </>
                                      ) : (
                                        <div
                                          className={
                                            !isPremiumUser &&
                                            Is_Agent_Created &&
                                            syndicationFeed === "agents" &&
                                            syndicationPrivacy === "show"
                                              ? "blue-text"
                                              : ""
                                          }
                                          onClick={() => {
                                            if (
                                              (isPremiumUser &&
                                                syndicationPrivacy ===
                                                  "show") ||
                                              (!isPremiumUser &&
                                                syndicationPrivacy === "show" &&
                                                syndicationFeed === "public")
                                            ) {
                                              PremiumPlanModal();
                                            }
                                          }}
                                        >
                                          {syndicationPrivacy === "hide"
                                            ? "Represented by Agent"
                                            : syndicationPrivacy === "show" &&
                                                syndicationFeed === "agents"
                                              ? "Upgrade to see the Agent who posted"
                                              : ""}

                                          {!isPremiumUser &&
                                            Is_Agent_Created &&
                                            syndicationFeed === "agents" &&
                                            syndicationPrivacy === "show" && (
                                              <div style={{ margin: "0 5px" }}>
                                                <img
                                                  src={PremiumFeatureStar}
                                                  alt="Premium Star"
                                                />
                                              </div>
                                            )}
                                        </div>
                                      )}
                                    </div>
                                    {/* below is for company details */}
                                    <div className="property-agent-requested-infoo">
                                      {((isPremiumUser &&
                                        syndicationPrivacy === "show") ||
                                        (!isPremiumUser &&
                                          syndicationPrivacy === "show" &&
                                          syndicationFeed === "public")) &&
                                        `Agent @ ${_.get(
                                          adDetails,
                                          "userCompany",
                                          "",
                                        )}`}
                                      {/* below code is for agent bio page redirection */}
                                      {((isPremiumUser &&
                                        syndicationPrivacy === "show") ||
                                        (!isPremiumUser &&
                                          syndicationPrivacy === "show" &&
                                          syndicationFeed === "public")) && (
                                        <>
                                          <NavLink
                                            to={`/agent-info/${agentSlug}`}
                                            className="blue-text"
                                            onClick={() => {
                                              navigate(
                                                `/agent-info/${agentSlug}`,
                                              );
                                            }}
                                          >
                                            View bio & contact info
                                          </NavLink>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <div className="property-not-agent-name">
                                    <span className="timeline-value">
                                      {consumerType}
                                    </span>
                                  </div>
                                )}
                              </>
                            ) : syndicationPrivacy === "show" ? (
                              <>
                                <span className="list-icn-wrap">
                                  <img
                                    src={userAvatar || DefaultProfile}
                                    alt="avatar"
                                    className="property-agent-profile"
                                    width={"40px"}
                                    height={"40px"}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      navigate(`/agent-info/${agentSlug}`);
                                    }}
                                  />
                                </span>
                                <div className="property-agent-details">
                                  <div className="property-agent-name">
                                    <>
                                      {WantCreatedUserName}
                                      <span className="pro-tag">PRO</span>
                                    </>
                                  </div>
                                  <div className="property-agent-requested-infoo">
                                    Agent @{" "}
                                    {_.get(adDetails, "userCompany", "")}
                                    <>
                                      <NavLink
                                        to={`/agent-info/${agentSlug}`}
                                        className="blue-text"
                                        onClick={() => {
                                          navigate(`/agent-info/${agentSlug}`);
                                        }}
                                      >
                                        View bio & contact info
                                      </NavLink>
                                    </>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <span className="list-icn-wrap">
                                  <img src={ConsumerIcon} />
                                </span>
                                {_.get(adDetails, "isAgentCreated", "") == 1 &&
                                createdUserTypeId !== 1
                                  ? " Represented by Agent"
                                  : consumerType}{" "}
                                {wantAdCreatedUserPlan ===
                                INVESTOR_MEMBER_PLAN ? (
                                  <span className="pro-gold-badge">
                                    Investor Member
                                  </span>
                                ) : (
                                  ""
                                )}
                              </>
                            )}

                            {/* ------------------------- Commented on 02-03-2024 based on basecamp post Premium Agent to Premium Agent Visabile Profiles------------------- */}
                            {/* </>
                        } */}
                            {/* ------------------------- Commented on 02-03-2024 based on basecamp post Premium Agent to Premium Agent Visabile Profiles------------------- */}
                          </li>
                          {loadBuyerAgreement()}
                          {loadTimeLine()}
                          {loadPreferredLocation()}
                          {loadStrengthenDetails()}
                        </ul>
                      </div>

                      {(adType == BUY ||
                        _.get(adDetails, "prprtyType", "") == IS_LAND) &&
                        _.get(adDetails, "isAgentCreated", "") == 1 &&
                        _.get(adDetails, "compenationType", "") > 0 && (
                          <div className="buyer-info">
                            <h2 className="wanted-details-head">
                              Requested Concessions From Seller
                            </h2>
                            <ul>
                              {_.get(adDetails, "compenationType", "") &&
                              (![1, 2].includes(
                                _.get(adDetails, "compenationType", ""),
                              ) ||
                                _.get(adDetails, "agentCompenation", null) !==
                                  null) ? (
                                <li>
                                  <span className="list-icn-wrap">
                                    <img src={FinancingIcon} />
                                  </span>
                                  <span className="timeline-value">
                                    {loadCompensationText(
                                      parseInt(
                                        _.get(adDetails, "compenationType", ""),
                                      ),
                                      _.get(adDetails, "agentCompenation", ""),
                                    )}
                                  </span>
                                </li>
                              ) : (
                                ""
                              )}
                              {_.get(adDetails, "otherConcessions", "") ? (
                                <li>
                                  {_.get(adDetails, "otherConcessions", "")}
                                </li>
                              ) : (
                                ""
                              )}
                            </ul>
                          </div>
                        )}
                      {wantAdCreatedUserPlan === INVESTOR_MEMBER_PLAN &&
                        purchaseType === 3 && (
                          <div className="buyer-info">
                            {_.get(adDetails, "investmentId", [])?.length > 0 ||
                            _.get(adDetails, "capRateId", null) ? (
                              <h2>What This Investor is Open to</h2>
                            ) : (
                              ""
                            )}
                            <ul>
                              {loadInvestmentCriteria(adDetails)}
                              {_.get(adDetails, "capRateId", null) && (
                                <li>
                                  <span className="list-icn-wrap">
                                    <img src={MinCapIcon} />
                                  </span>
                                  Minimum cap rate of{" "}
                                  {_.get(adDetails, "capRateId", "") == 15
                                    ? "15+"
                                    : _.get(adDetails, "capRateId", "")}
                                  %
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                    </div>
                  </div>

                  {!isFromAllIntroduction && (
                    <div className="col-12 col-md-5 pe-md-3 col-lg-4 pe-lg-3 col-xl-4 pe-xl-2">
                      {showStrengthen && loggedInUserId && (
                        <div className="ad-strengthen-wrap mb-4">
                          <div className="icon-wrap">
                            <img src={StrengthenIcon} alt={StrengthenIcon} />
                          </div>
                          <h4>Want to get more attention on your listing?</h4>
                          <p className="mb-4">
                            Adding additional information to your listing gives
                            owners a better idea of what you're looking for.{" "}
                          </p>
                          <Button
                            variant="primary"
                            className="w-100 mb-4"
                            onClick={() => handleStrengthenClick()}
                          >
                            Strengthen my listing
                          </Button>
                          <a
                            href={void 0}
                            role="button"
                            className="dismiss-btn d-block"
                            onClick={() => handleStrengthenDismiss()}
                          >
                            Dismiss
                          </a>
                        </div>
                      )}
                      {WantCreatedUserId &&
                      WantCreatedUserId != loggedInUserId &&
                      loggedInUserId ? (
                        <SendIntroduction
                          wantAdId={wantAdId}
                          WantCreatedUserName={WantCreatedUserName}
                          WantCreatedUserId={WantCreatedUserId}
                          wantAdClientId={wantAdClientId}
                          wantAdDetails={adDetails}
                        />
                      ) : isLoadIntroductionList && introductionList?.length ? (
                        <ViewWantAdIntroductions
                          introCount={introCount}
                          list={introductionList}
                          updateIntroPageOnScroll={updateIntroPageOnScroll}
                          getIntroductionDetails={getIntroductionDetails}
                        />
                      ) : (
                        <>
                          <div className="ad-strengthen-wrap mb-0 mb-sm-4">
                            {loggedInUserId && (
                              <>
                                <div className="icon-wrap">
                                  <img src={AdIntroIcon} alt={AdIntroIcon} />
                                </div>
                                <h6 className="send-instruction-head">
                                  When you receive a new introduction you'll see
                                  it here
                                </h6>
                                <p className="mb-2 wanted-info-listdetail">
                                  Start a message thread by either sending or
                                  responding to an introduction on a want ad
                                </p>
                              </>
                            )}

                            {!loggedInUserId && (
                              <>
                                <div className="icon-wrap">
                                  <img src={AdIntroIcon} alt={AdIntroIcon} />
                                </div>
                                <h6 className="send-instruction-head">
                                  Send Them Your Property
                                </h6>
                                <p className="mb-4 wanted-info-listdetail">
                                  Do you own or represent a property that sounds
                                  like a match? Introduce it!
                                </p>

                                <a
                                  href={void 0}
                                  onClick={() => {
                                    setRefresh((prev) => prev + 1);
                                  }}
                                  className="add-your-property-wrap link-wrap"
                                  id="propertySelection"
                                >
                                  <div className="add-property-btn">
                                    <img
                                      src={AddPropertyIcon}
                                      alt={AddPropertyIcon}
                                    />
                                  </div>
                                  <div className="make-intro-details">
                                    <h3 className="mb-0 agent-property-heading">
                                      Add your property
                                    </h3>
                                  </div>

                                  <span
                                    role="button"
                                    className="right-arrow-link"
                                    href={void 0}
                                    onClick={() => {}}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M7.05806 3.30806C7.30214 3.06398 7.69786 3.06398 7.94194 3.30806L14.1919 9.55806C14.436 9.80214 14.436 10.1979 14.1919 10.4419L7.94194 16.6919C7.69786 16.936 7.30214 16.936 7.05806 16.6919C6.81398 16.4479 6.81398 16.0521 7.05806 15.8081L12.8661 10L7.05806 4.19194C6.81398 3.94786 6.81398 3.55214 7.05806 3.30806Z"
                                        fill="#000022"
                                      />
                                    </svg>
                                  </span>
                                </a>

                                <div className="addyour-property-details-wrap position-relative property-price">
                                  <div className="property-dollar-icon">$</div>
                                  <ToolTip
                                    title={
                                      "This number is meant to start a conversation and can be changed as you negotiate"
                                    }
                                  />

                                  <label className="form-label">
                                    Asking price
                                  </label>
                                  <TextBox
                                    id="askingprice"
                                    name="askingPrice"
                                    type="text"
                                    value={""}
                                    placeholder={0}
                                    className="property-txt-fld property-txt-leftpad"
                                    disabled={true}
                                  />
                                </div>

                                <div className="addyour-property-details-wrap mb-12 property-message">
                                  <label className="form-label">
                                    Message (optional)
                                  </label>
                                  <TextArea
                                    name="message"
                                    id="message"
                                    className="form-control"
                                    value={""}
                                    maxLength={450}
                                    placeholder="Hey there! I think my property matches what you're looking for."
                                    disabled={true}
                                  />
                                  <div className="des-count align-self-end">
                                    0/450
                                  </div>
                                </div>

                                <Button
                                  variant="primary"
                                  className="w-100 mb-0 l-spacing-0 sendMessageBtn"
                                  disabled={true}
                                >
                                  Review Introduction
                                </Button>

                                {showIntroLink && (
                                  <Button
                                    variant=""
                                    className="w-100 l-spacing-0 btn-no-bg mt-3"
                                    onClick={(e) => {
                                      IntroTutorialShow();
                                    }}
                                  >
                                    Show me how this works
                                  </Button>
                                )}

                                <IntroTutorialModal
                                  show={showIntroTutorialModal}
                                  onHide={IntroTutorialModalClose}
                                  accept={acceptTutorial}
                                />
                              </>
                            )}
                          </div>

                          {sessionData?.userInfo?.userId && (
                            <div className="share-card-wrapper share-sidecard">
                              <ShareCard
                                wantAdId={wantAdId}
                                isSideCard={true}
                                adDetails={adDetails}
                                isWantAdCreated={isWantAdCreated}
                                shareLink={shareUrl}
                                fromWantAdDetails={true}
                                imageLink={imageUrl}
                                fbLink={fbUrl}
                              />
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>

          {!noWantAdFound && showShareModal && loggedInUserId && (
            <ShareYourAdModal
              show={showShareModal}
              onHide={handleClose}
              adDetails={adDetails}
              isWantAdCreated={isWantAdCreated}
              shareLink={shareUrl}
              imageLink={imageUrl}
              fbLink={fbUrl}
              fromWantAdDetails={true}
            />
          )}

          <ShareMyWantAdSmallModal
            show={showSuccessModal}
            onHide={handleSuccessModalClose}
            showShareModalPopup={showShareModalPopup}
          />
          <NoWantAdFoundModal show={noWantAdFound} />
          <ReportWantAdModal
            show={showReportModal}
            wantAdId={wantAdId}
            onHide={() => handleReportPopup(false)}
          />
          {introDetails.length > 0 && (
            <ViewIntroductionModal
              details={introDetails?.[0]}
              show={showViewIntroductionModal}
              onHide={handleIntroDetailModal}
            />
          )}
          {/*  Add to client favorite Modal */}
          <AddToClientWantAdModal
            show={modalShow}
            showAddToClientWantAdModal={() => setModalShow(true)}
            onHide={() => setModalShow(false)}
            data={results}
            handleSkip={() =>
              handleFavoriteOrUnfavoriteWantAd(isFavourite, wantAdId)
            }
            handleConfirm={handleClientFavoriteWantAd}
            searchText={searchText}
            onChangeText={(e) => onChangeText(e)}
            onAddClient={() => setReloadAgents(reloadAgents + 1)}
          />
          <DeleteModal
            show={deleteModalShow}
            onHide={() => setDeleteModalShow(false)}
            title={"Are you sure you want to permanently delete your want-ad?"}
            message={
              "Deleting this ad will stop any further introductions from being sent to you."
            }
            buttonText={" Delete Want-Ad"}
            handleConfirm={() => handleDeleteWantAd()}
          />
          <ArchiveModal
            show={archiveModalShow}
            onHide={() => setArchiveModalShow(false)}
            handleConfirm={() => handleArchiveWantAd()}
          />
          <AgentProfileViewModal
            show={showAgentProfileViewModal}
            onClose={agentProfileViewModalClose}
            userId={_.get(adDetails, "userId", "")}
            isTitleShow={true}
          />
          <PremiumPlanModal
            userDetails={userDetailsFromStore[0]}
            show={showPremiumPlanModal}
            onHide={PremiumPlanModalClose}
            showPlanModal={PremiumPlanModalShow}
          />
        </>
      )}
    </>
  );
};

export default WantadDetails;
